import * as React from "react";
import { Drawer, DrawerProps } from "antd";
import { classNames } from "src/common/classNames";
import styles from "./DrawerPlm.module.less";

export type PropsDrawerPlm = DrawerProps;

export const DrawerPlm: React.FC<PropsDrawerPlm> = (props) => {
  const {
    classNames: classNamesProp = {},
    width = "75vw",
    ...restProps
  } = props;

  return (
    <Drawer
      {...restProps}
      width={width}
      classNames={{
        content: classNames([styles.content, classNamesProp.content]),
        header: classNames([styles.header, classNamesProp.header]),
        body: classNames([styles.body, classNamesProp.body]),
        footer: classNames([styles.footer, classNamesProp.footer]),
      }}
    />
  );
};
